import React from "react";
import { Container } from "reactstrap";
import "../../styles/returnpolicy.css"

const ReturnPolicy = () => {
  return (
    <Container className="py-5 return-policy">
      <h1>Chính sách đổi trả & Hoàn tiền</h1>
      <p>Do đặc thù hàng thực phẩm, Mekong Zone quy định:</p>
      <ul>
        <li><strong>Điều kiện:</strong> Sản phẩm lỗi sản xuất, hết hạn hoặc hư hỏng do vận chuyển.</li>
        <li><strong>Thời gian:</strong> Phản hồi sau khi nhận hàng trong 24h.</li>
        <li><strong>Hình thức:</strong> Đổi sản phẩm mới cùng loại hoặc hoàn tiền qua chuyển khoản.</li>
      </ul>
      <p>Hotline tiếp nhận khiếu nại: +(84) 941 604 103</p>
    </Container>
  );
};

export default ReturnPolicy;